import loadable from "@loadable/component"
import { RouteObject } from "react-router-dom"

import { APP_ROUTES } from "~/shared/constants/routes"

const CargoOwnerListLayout = loadable(
  async () => import("~/features/cargo-owners/pages/CargoOwnerListLayout"),
  { fallback: <></> },
)

const CargoOwnerListPage = loadable(
  async () => import("~/features/cargo-owners/pages/CargoOwnerListPage"),
  { fallback: <></> },
)

const CargoOwnerDetailsLayout = loadable(
  async () => import("~/features/cargo-owners/pages/CargoOwnerDetailsLayout"),
  { fallback: <></> },
)

const CargoOwnerDetailsPage = loadable(
  async () => import("~/features/cargo-owners/pages/CargoOwnerDetailsPage"),
  { fallback: <></> },
)

const CargoOwnerBranchLayout = loadable(
  async () => import("~/features/cargo-owners/pages/CargoOwnerBranchLayout"),
  { fallback: <></> },
)

const CargoOwnerBranchPage = loadable(
  async () => import("~/features/cargo-owners/pages/CargoOwnerBranchPage"),
  { fallback: <></> },
)

export const cargoOwnerRoutes: RouteObject[] = [
  {
    path: APP_ROUTES.cargoOwners,
    element: <CargoOwnerListLayout />,
    children: [{ index: true, element: <CargoOwnerListPage /> }],
  },
  {
    path: `${APP_ROUTES.cargoOwners}/:cargoOwnerId`,
    element: <CargoOwnerDetailsLayout />,
    children: [{ index: true, element: <CargoOwnerDetailsPage /> }],
  },
  {
    path: `${APP_ROUTES.cargoOwners}/:cargoOwnerId/:cargoOwnerBranchId`,
    element: <CargoOwnerBranchLayout />,
    children: [{ index: true, element: <CargoOwnerBranchPage /> }],
  },
]
